module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subscribe-form textbody"
  }, [_c('h4', [_vm._v("Receive news of future releases")]), _vm._v(" "), _c('p', [_vm._v("Dovedale will be regularly realising new collections. We would like to keep you updated and informed. Please subscribe or contact us for custom orders.")]), _vm._v(" "), _c('form', {
    staticClass: "h8 nimbus-sans",
    attrs: {
      "id": "subscribeForm",
      "action": '//dovedaledesignstudio.us15.list-manage.com/subscribe/post?u=f5497669bd87e7e8a503aeb85&id=' + _vm.mailchimpNewsletterID,
      "method": "post",
      "name": "mc-embedded-subscribe-form",
      "target": "_blank"
    },
    on: {
      "submit": _vm.submit
    }
  }, [_c('input', {
    attrs: {
      "type": "email",
      "value": "",
      "placeholder": "Your Email",
      "name": "EMAIL",
      "id": "mce-EMAIL",
      "required": ""
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('input', {
    attrs: {
      "type": "submit",
      "value": "Sign Up",
      "name": "subscribe",
      "id": "mc-embedded-subscribe"
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "absolute",
      "left": "-5000px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('input', {
    attrs: {
      "type": "text",
      "name": "b_f5497669bd87e7e8a503aeb85_a60f52dceb",
      "tabindex": "-1",
      "value": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f8150adc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SubscribeForm.vue
// module id = 400
// module chunks = 1